import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  
  ico: AnimationOptions = {
    path: '../assets/animations/sun-weather.json'
  };

  constructor() { }

  ngOnInit() {
  }

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  goToLoc() {
   window.location.href="https://www.google.com/maps/dir/45.407786,11.898747/assicurazioni+francaviglia/@45.3596682,11.9035487,12z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x477ec1ad1914cc23:0x5b1886f11735e1c!2m2!1d12.0355941!2d45.2981412"
  }
}
